import * as Api from '@/api'

const API_LIST = '/survey'
const API_SHOW = '/participants/:id/'
const API_CREATE = '/answer'
const API_UPDATE = '/survey/:id'
const API_CLOSE_SURVEY = '/survey/:token/close'

export default {
  list () {
    return Api.http().get(API_LIST)
  },
  show (id) {
    return Api.http().get(API_SHOW.replace(':id', id))
  },
  post (data) {
    return Api.http().post(API_CREATE, data)
  },
  put (id, data) {
    return Api.http().put(API_UPDATE.replace(':id', id), data)
  },
  closeSurvey (token, payload) {
    return Api.http().patch(API_CLOSE_SURVEY.replace(':token', token))
  }
}
